import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const floatingWrapper = css`
  background-color: ${cssTheme.colors.absolute.white};
`

export const actionButtonWrapper = css`
  padding-block-end: ${spacing(5)};

  border-end-end-radius: 0;
  border-end-start-radius: 0;
`

export const slotsGrid = css`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  inline-size: 100%;
  align-items: center;
`

export const slotLeading = css`
  grid-column: 1;
  justify-self: start;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const slotCenter = css`
  grid-column: 2;
  justify-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const slotTrailing = css`
  grid-column: 3;
  justify-self: end;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const disabledOpacityOverride = css`
  &:disabled {
    opacity: 1;
  }
`
